import { render, staticRenderFns } from "./CustomerCity.vue?vue&type=template&id=27596ab4"
import script from "./CustomerCity.vue?vue&type=script&lang=js"
export * from "./CustomerCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports